import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card-body" };
const _hoisted_2 = { class: "body2-text text-black" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "body2-text text-black" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "body2-text text-black" };
const _hoisted_7 = { class: "body2-text text-black" };
const _hoisted_8 = { class: "body2-text text-black" };
const _hoisted_9 = { class: "body2-text text-black" };
const _hoisted_10 = { class: "body2-text text-black" };
const _hoisted_11 = { class: "body2-text text-black" };
const _hoisted_12 = { class: "body2-text text-black" };
const _hoisted_13 = { class: "body2-text text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PayType = _resolveComponent("PayType");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_Chip = _resolveComponent("Chip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" 접수 가능 결제방식 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}goods_pay_restrict_type`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_PayType, {
                    "is-full-text": "",
                    "pay-types": _ctx.goodsPayRestrictType
                }, null, 8 /* PROPS */, ["pay-types"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상품 대금 전달 방식 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}goods_pay_type`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_Chip, {
                    text: _ctx.detail.formattedGoodsPayTypeObj.text,
                    "brg-chip-color": _ctx.detail.formattedGoodsPayTypeObj.color
                }, null, 8 /* PROPS */, ["text", "brg-chip-color"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 완료전 상품대금 정산 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}is_send_baromoney_required`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.isSendBaromoneyRequiredText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 현금영수증 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}is_cash_receipts_required`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.isCashReceiptsRequiredText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 픽업소요시간 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}cooking_time`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.cookingTimeText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 접수 가능 건수 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}day_delivery_available_count`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.detail.formattedDayDeliveryCount), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 자동 취소시간 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}delivery_cancel_time`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.deliveryCancelTimeText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 접수 제한 잔액 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}order_limit_baromoney`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.detail.formattedOrderLimitBaromoney), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 접수제한금액 부족 시 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}insufficient_baromoney_unaccept_yn`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.isInsufficientBaromoneyUnAcceptText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 배달대행료 미설정 구간 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}is_delivery_charge_non_setting_unaccept`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.isDeliveryChargeNonSettingUnAcceptText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 기본 할증기능 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}add_charge_use_yn`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.addChargeUseYnText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 설정할증 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}setting_charge`),
            "wide-title": "",
            "show-tooltip": "",
            "tooltip-text": _ctx.$t(`${_ctx.storeDetailLc}edit_available_in_operation_setting`)
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.addChargeApplyYnText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "tooltip-text"]),
        _createCommentVNode(" 수행상황 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}delivery_status`),
            "wide-title": "",
            "show-tooltip": "",
            "tooltip-text": _ctx.$t(`${_ctx.storeDetailLc}edit_available_in_operation_setting`)
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.detail.formattedAddCookingTime), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "tooltip-text"]),
        _createCommentVNode(" 추가할증 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.storeDetailLc}delivery_charge`),
            "wide-title": "",
            "show-tooltip": "",
            "tooltip-text": _ctx.$t(`${_ctx.storeDetailLc}edit_available_in_operation_setting`)
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.detail.formattedAddDeliveryCharge), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "tooltip-text"])
    ]));
}
